import * as myStore from '../store/myStore';
import messageBufferStorage from '../functions/messageBufferStorage';
import { CHAT_TYPES, MAXIMUM_RESEND_MESSAGE_TIME } from '../constants/constants';
import { messageTypes } from '../constants';
import { messageActions } from './index';
import webIMConfig from '../libs/webIMConfig';
import * as conversationDetailAction from './conversationDetailAction';
import { TYPE_IMAGE, TYPE_VIDEO_FILE } from '../constants/messageTypes';
import { removeStatusErrorMessage } from './messageActions';

const messageCount = {};

function getStore() {
  return myStore.getStore();
}

function getLoginReducer() {
  return getStore().getState().loginReducer;
}

function getMessageReducer() {
  return getStore().getState().messageReducer;
}

export function saveMessageToBufferStorage(message) {
  // console.log("saveMessageToBufferStorage", message, message.id);
  if (message && (!messageCount[message.id] || !messageCount[message.id]?.count || messageCount[message.id]?.count < MAXIMUM_RESEND_MESSAGE_TIME)) {
    if (!messageCount[message.id] || !messageCount[message.id]?.count) {
      messageCount[message.id] = {
        count: 0,
      };
    }
    messageCount[message.id].count += 1;
    messageBufferStorage.setMessage(message);
  }
}

export function updateMessageError(messageId) {
  // console.log("updateMessageError", messageId);
  messageBufferStorage.updateMessageError(messageId);
}

export function removeMessageFromBufferStorage(messageId, isSent) {
  return dispatch => {
    // console.log("removeMessageFromBufferStorage", messageId, isSent);
    if (isSent) {
      // console.log("updateMessageSent:", messageId);
      dispatch(messageActions.updateMessageSent(messageId));
    }
    return messageBufferStorage.deleteMessage(messageId);
  };
}

export function handleSendBufferMessage() {
  return dispatch => {
    // console.log("do handleSendBufferMessage");
    // const messageBufferObject =
    return messageBufferStorage.getMessages().then(messageBufferObject => {
      // console.log("messageBufferObject", messageBufferObject);
      const messageArray = Object.values(messageBufferObject);
      const messageReducer = getMessageReducer();
      const loginReducer = getLoginReducer();

      const handleSendBufferMessageCallback = _messageBufferObject => {
        // console.log("handleSendBufferMessageCallback:", _messageBufferObject);
        Object.keys(_messageBufferObject).forEach(messageId => {
          // handle send here
          if (!messageId) {
            return;
          }
          const loginXmppId = loginReducer.userInfo.xmppId;
          const message = _messageBufferObject[messageId];
          if (message && message.from === loginXmppId && +new Date() - message.time > webIMConfig.pingTimeout) {
            // console.log("send buffer message: ", message.id, message);
            if (message.type === CHAT_TYPES.GROUP_CHAT) {
              // console.log("message groupchat", message);
              // dispatch(messageActions.removeMessageErrorSuccess(messageId));
              switch (message.body.type) {
                case messageTypes.TYPE_TEXT: {
                  dispatch(removeMessageFromBufferStorage(messageId));
                  dispatch(
                    messageActions.sendTxtMessage(CHAT_TYPES.GROUP_CHAT, message.to, message.body.data, 1, 1, false, false, messageId, {
                      convId: message.convId,
                    })
                  ).then(res => {
                    // dispatch(removeStatusErrorMessage(messageId));
                  });
                  break;
                }
                default:
                  break;
              }
            } else if (message.type === CHAT_TYPES.CHAT) {
              // if (message.error) {
              // Remove message in reducer
              // dispatch(messageActions.removeMessageErrorSuccess(messageId));
              // }
              switch (message.body.type) {
                case messageTypes.TYPE_TEXT:
                  // console.log("remove from buffer action");
                  dispatch(removeMessageFromBufferStorage(messageId));
                  dispatch(
                    messageActions.sendTxtMessage(
                      CHAT_TYPES.CHAT,
                      message.to,
                      message.body.data,
                      message.body.senderMemberLevel,
                      message.body.recvMemberLevel,
                      message.body.isRecvMatching,
                      message.body.isSenderMatching,
                      messageId,
                      {
                        convId: message.convId,
                      }
                    )
                  ).then(res => {
                    // dispatch(removeStatusErrorMessage(messageId));
                  });
                  break;
                case messageTypes.TYPE_GIFT:
                  // console.log("remove from buffer action");
                  dispatch(removeMessageFromBufferStorage(messageId));
                  dispatch(
                    messageActions.sendGift(
                      CHAT_TYPES.CHAT,
                      message.to,
                      message.body.data,
                      messageId,
                      message.body.senderMemberLevel,
                      message.body.recvMemberLevel,
                      message.body.isRecvMatching,
                      message.body.isSenderMatching,
                      {
                        convId: message.convId,
                      }
                    )
                  ).then(res => {
                    // dispatch(removeStatusErrorMessage(messageId));
                  });
                  break;
                case messageTypes.TYPE_GALLERY:
                  dispatch(removeMessageFromBufferStorage(messageId));
                  dispatch(
                    messageActions.sendGalleryMessage(
                      CHAT_TYPES.CHAT,
                      message.to,
                      message.body.data,
                      message.body.senderMemberLevel,
                      message.body.recvMemberLevel,
                      message.body.isRecvMatching,
                      message.body.isSenderMatching,
                      messageId,
                      {
                        convId: message.convId,
                      }
                    )
                  ).then(res => {
                    // dispatch(removeStatusErrorMessage(messageId));
                  });
                  break;
                case messageTypes.TYPE_GIF:
                  dispatch(removeMessageFromBufferStorage(messageId));
                  dispatch(
                    messageActions.sendGifMessage(
                      CHAT_TYPES.CHAT,
                      message.to,
                      message.body.data,
                      message.body.senderMemberLevel,
                      message.body.recvMemberLevel,
                      message.body.isRecvMatching,
                      message.body.isSenderMatching,
                      messageId,
                      {
                        convId: message.convId,
                      }
                    )
                  ).then(res => {
                    // dispatch(removeStatusErrorMessage(messageId));
                  });
                  break;
                case messageTypes.TYPE_IMAGE:
                case messageTypes.TYPE_VIDEO_FILE:
                  dispatch(removeMessageFromBufferStorage(messageId));
                  const source = {
                    body: {
                      data: message.body.data,
                      url: message.body.data,
                      type: message.body.type,
                    },
                  };
                  dispatch(
                    messageActions.sendMediaMessage(
                      CHAT_TYPES.CHAT,
                      message.to,
                      '',
                      source,
                      message.body.senderMemberLevel,
                      message.body.recvMemberLevel,
                      message.body.isRecvMatching,
                      message.body.isSenderMatching,
                      true,
                      undefined,
                      messageId,
                      {
                        convId: message.convId,
                      }
                    )
                  ).then(res => {
                    // dispatch(removeStatusErrorMessage(messageId));
                  });
                  break;
                case messageTypes.TYPE_SHARE_LOCATION:
                  dispatch(removeMessageFromBufferStorage(messageId));
                  dispatch(
                    messageActions.sendShareLocationMessage(
                      CHAT_TYPES.CHAT,
                      message.to,
                      message.body.data,
                      {
                        senderMemberLevel: message.body.senderMemberLevel,
                        recvMemberLevel: message.body.recvMemberLevel,
                        isRecvMatching: message.body.isRecvMatching,
                        isSenderMatching: message.body.isSenderMatching,
                      },
                      messageId,
                      {
                        convId: message.convId,
                      }
                    )
                  ).then(res => {
                    // dispatch(removeStatusErrorMessage(messageId));
                  });
                  break;
                case messageTypes.TYPE_SHARE_DATE:
                  dispatch(removeMessageFromBufferStorage(messageId));
                  dispatch(
                    messageActions.sendShareDateFinderMessage(
                      CHAT_TYPES.CHAT,
                      message.to,
                      message.body.data,
                      {
                        senderMemberLevel: message.body.senderMemberLevel,
                        recvMemberLevel: message.body.recvMemberLevel,
                        isRecvMatching: message.body.isRecvMatching,
                        isSenderMatching: message.body.isSenderMatching,
                      },
                      messageId,
                      {
                        convId: message.convId,
                      }
                    )
                  ).then(res => {
                    // dispatch(removeStatusErrorMessage(messageId));
                  });
                  break;
                case messageTypes.TYPE_SHARE_EVENT:
                  dispatch(removeMessageFromBufferStorage(messageId));
                  dispatch(
                    messageActions.sendShareEventMessage(
                      CHAT_TYPES.CHAT,
                      message.to,
                      message.body.data,
                      {
                        senderMemberLevel: message.body.senderMemberLevel,
                        recvMemberLevel: message.body.recvMemberLevel,
                        isRecvMatching: message.body.isRecvMatching,
                        isSenderMatching: message.body.isSenderMatching,
                      },
                      messageId,
                      {
                        convId: message.convId,
                      }
                    )
                  ).then(res => {
                    // dispatch(removeStatusErrorMessage(messageId));
                  });
                  break;
                default:
                  break;
              }
            }
          }
        });
      };

      if (messageArray[0] && messageArray[0].to) {
        const toXmppId = messageArray[0].to;
        if (messageReducer.groupchat[toXmppId]) {
          // is group chat message
          handleSendBufferMessageCallback(messageBufferObject);
        } else if (messageReducer.chat[toXmppId]) {
          // There is already messages to toXmppId in message reducer, so this is not case refresh
          handleSendBufferMessageCallback(messageBufferObject);
        } else {
          // Get new data messages of messageArray
          const actionGetMessages = [];
          const setCalled = new Set();
          messageArray.forEach(message => {
            if (message.type === CHAT_TYPES.CHAT && !setCalled.has(message.to)) {
              setCalled.add(message.to);
              actionGetMessages.push(dispatch(conversationDetailAction.getConversationDetails(loginReducer, { xmppId: message.to })));
            }
          });
          Promise.all([...actionGetMessages]).then(responses => {
            if (responses.length > 0) {
              const _messageBufferObject = {};
              Object.keys(messageBufferObject)
                .filter(mid => messageReducer.byId[mid])
                .forEach(messageId => {
                  _messageBufferObject[messageId] = messageBufferObject[messageId];
                });
              handleSendBufferMessageCallback(_messageBufferObject);
            }
          });
        }
      }
    });
  };
}
